import _ from 'lodash';
import { FTProcessRow } from '@/models/FTProcessRow';
import { weightToLength } from '../index';

export const lamination = ( frontRMFtProcessRow: FTProcessRow, backRMFtProcessRow: FTProcessRow, adhesiveFtProcessRow: FTProcessRow ) => {
  const outputFTProcessRow =  frontRMFtProcessRow.ftProcess.outputs[0];
  if(frontRMFtProcessRow._id) {
    outputFTProcessRow.goodsObject.copyFrom(frontRMFtProcessRow.goodsObject);
  }
  let frontRMLinearLength = 0;
  if(frontRMFtProcessRow.quantity && frontRMFtProcessRow.goodsObject.dimensions) {
    frontRMLinearLength = weightToLength(frontRMFtProcessRow.quantity, frontRMFtProcessRow.goodsObject.density, frontRMFtProcessRow.goodsObject.dimensions.width);
  }
  const totalLinearLength = frontRMLinearLength || 0;
  outputFTProcessRow.quantity = (frontRMFtProcessRow.quantity || 0) + (backRMFtProcessRow.quantity || 0) + (adhesiveFtProcessRow.quantity || 0);
  if(frontRMFtProcessRow.quantity) {
    outputFTProcessRow.goodsObject.density = _.round((outputFTProcessRow.quantity * 1000)/((_.get(frontRMFtProcessRow, 'goodsObject.dimensions.width', 0)/1000) * totalLinearLength), 2);
    outputFTProcessRow.goodsObject.setPerKgRatio('plA', (_.get(frontRMFtProcessRow, 'goodsObject.perKgRatio.plA.value', 0) * frontRMFtProcessRow.quantity) / outputFTProcessRow.quantity)
  }
  return outputFTProcessRow;
}
